// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_guided_relaxations: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `<strong>Guided Relaxations</strong><br>Yoga International’s guided relaxations invite you to find stillness and release tension. These simple yet effective practices can improve mental function and help you better manage stress.`,
    es: `<strong>Relajaciones Guiadas</strong><br>Las relajaciones guiadas de Yoga International te invitan a encontrar la quietud y a liberar la tensión. Estas prácticas simples pero efectivas pueden mejorar la función mental y ayudarte a manejar mejor el estrés.`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_guided_relaxations';
};
